import * as d3 from "d3";

import {formatMoney} from '../../common';

// set the dimensions and margins of the graph
var margin = {top: 20, right: 0, bottom: 0, left: 0},
    width = 460 - margin.left - margin.right,
    height = 400 - margin.top - margin.bottom;


var grp;

const colors = [
  '#D5f2E3',
  '#73BA9B',
  '#9F87AE',
  '#E3C5FC'
];

// append the svg object to the body of the page
var svg = d3.select("#welcome-violin")
  .append("svg")
    //.attr("width", width + margin.left + margin.right)
  //  .attr("height", height + margin.top + margin.bottom)
    .attr("viewBox", `0 0 ${width} ${height}`)
  .append("g")
    .attr("transform",
          "translate(" + margin.left + "," + margin.top + ")");

// Parse the Data
d3.json('/api/welcome/violin', function(data) {
//d3.csv('https://raw.githubusercontent.com/holtzy/data_to_viz/master/Example_dataset/5_OneCatSevNumOrdered_wide.csv', function(data) {

  //console.log('data', data)

  const maxValue = Math.max(...data.reduce((accumulator, current) => {
    accumulator.push(current["GOP Support"]);
    accumulator.push(current["GOP Oppose"]);
    accumulator.push(current["DEM Support"]);
    accumulator.push(current["DEM Oppose"]);
    return accumulator;
  }, [])) * 2;

  // List of groups = header of the csv files
  var keys = ['GOP Oppose', 'GOP Support', 'DEM Oppose', 'DEM Support'];
  //var keys = data.columns.slice(1);

  const tickValues = data.map(d => d.key);

  // Add X axis
  var x = d3.scaleLinear()
    .domain(d3.extent(data, function(d) { return d.key; }))
    .range([ 0, width ]);
  svg.append("g")
    .attr("transform", "translate(0," + height*0.8 + ")")
    .call(d3.axisBottom(x).tickSize(-height*.7).tickValues([0, 30, 60, 90, 120, 150, 180]))
    .select(".domain").remove()
  // Customization
  svg.selectAll(".tick line").attr("stroke", "#b8b8b8")

  // Add X axis label:
  svg.append("text")
      .attr("text-anchor", "end")
      .attr("x", width-20)
      .attr("y", height-30 )
      .attr('class', 'violin-caption')
      .text("7 Day Moving Average for Last 180 Days");

  // Add Y axis
  var y = d3.scaleLinear()
    .domain([maxValue*-1, maxValue])
    .range([ height, 0 ]);

  //stack the data?
    var stackedData = d3.stack()
      .offset(d3.stackOffsetSilhouette)
      .keys(keys)
      (data)

  // create a tooltip
  var Tooltip = svg
    .append("text")
    .attr("x", 0)
    .attr("y", 0)
    .style("opacity", 0)
    .style("font-size", 17)

    //console.log('stackedData', stackedData)







  // Three function that change the tooltip when user hover / move / leave a cell
  var mouseover = function(d) {
    //console.log('mouseover', d)
    Tooltip.style("opacity", 1)
    d3.selectAll(".myArea").style("opacity", .8)
    d3.select(this)
      .style("stroke", "#C4C4C4")
      .style("opacity", 1)
  }
  var mousemove = function(d,i,n) {
    grp = keys[i];
    const currentXPosition = d3.mouse(this)[0];
    const xValue = Math.abs(Math.ceil((currentXPosition / width)*180));
    if (data[xValue] && data[xValue])
    {
      Tooltip.text(`${grp} ${formatMoney(data[xValue][keys[i]])}`)
    }
    //console.log('data', data[x])
  }
  var mouseleave = function(d) {
    Tooltip.style("opacity", 0)
    d3.selectAll(".myArea").style("opacity", 1).style("stroke", "none")
   }

  // Area generator
  var area = d3.area()
    .x(function(d) { return x(d.data.key); })
    .y0(function(d) { return y(d[0]); })
    .y1(function(d) { return y(d[1]); })

  // Show the areas
  svg
    .selectAll("mylayers")
    .data(stackedData)
    .enter()
    .append("path")
      .attr("class", "myArea")
      .style("fill", function(d) {
        //console.log('fill', d)
        //return color(d.key);
        return colors[d.index];
      })
      .attr("d", area)
      .on("mouseover", mouseover)
      .on("mousemove", mousemove)
      .on("mouseleave", mouseleave);

      svg.append('line')
          .attr('x1', 0)
          .attr('y1', height / 2)
          .attr('x2', width)
          .attr('y2', height / 2)
          .attr("stroke", "#b8b8b8")
          .style('stroke-width', 1);

      const legendY = 20;
      svg.append("circle").attr("cx",10).attr("cy",legendY).attr("r", 6).style("fill", colors[1])
      svg.append("circle").attr("cx",120).attr("cy",legendY).attr("r", 6).style("fill", colors[0])
      svg.append("circle").attr("cx",230).attr("cy",legendY).attr("r", 6).style("fill", colors[3])
      svg.append("circle").attr("cx",340).attr("cy",legendY).attr("r", 6).style("fill", colors[2])
      svg.append("text").attr("x", 20).attr("y", legendY).text("GOP Support").style("font-size", "12px").attr("alignment-baseline","middle")
      svg.append("text").attr("x", 130).attr("y", legendY).text("GOP Oppose").style("font-size", "12px").attr("alignment-baseline","middle")
      svg.append("text").attr("x", 240).attr("y", legendY).text("DEM Support").style("font-size", "12px").attr("alignment-baseline","middle")
      svg.append("text").attr("x", 350).attr("y", legendY).text("DEM Oppose").style("font-size", "12px").attr("alignment-baseline","middle")




})
